import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IExpedition, IExpeditionNotification } from "@/models";

@Component({
    name: "NotificationExpedition",
})

export default class NotificationExpedition extends Vue {
    @Prop({ required: true })
    public notification: IExpeditionNotification;

    constructor() {
        super();
    }

    public goToCard(): void {
        this.$store.commit("expeditions/SET_SELECTED_NOTIFICATION", this.notification);
        this.$store.dispatch("expeditions/setSelectedExpedition", this.notification.expedition);
        if (this.notification.expedition.isArrived) {
            this.$router.push({ name: "ExpeditionCard" });
        } else {
            this.$router.push({ name: "ExpeditionCreate" });
        }
    }
}
